export default function TrainerDesign() {
  return (
    <div className="absolute top-0 left-0 w-2/4 z-0 pointer-events-none transform -skew-y-6 mt-4">
      <div className="w-2/5 bg-gradient-to-r from-green-300 to-transparent h-20"></div>
      <div className="w-5/6 bg-gradient-to-r from-green-200 to-transparent h-20"></div>
      <div className="w-2/4 bg-gradient-to-r from-green-100 to-transparent h-20"></div>
    </div>
  );
}
